const {trackGa, track} = require('./analytics/analytics');
const href = window.location.origin + "/";
import "../scss/style.scss";
import $ from "jquery";
import popper from "popper.js";
// import bootstrap from "bootstrap";
// import jQueryBridget from 'jquery-bridget';
import flickity from "flickity";
import './common';
const p = popper;
// const bs = bootstrap;
const flkt = flickity;
import adsFixer from './analytics/adsFixer';
const Help = require('./includes/help');
const { checkLocation } = require('./helpers/index');
const mainHelp = new Help();

//Main page scripts
// const about = window.location.pathname.includes('about');
const bundles = window.location.pathname.includes('bundles');
const bundlesChristmas = window.location.pathname.includes('bundles/christmas');
const blackFriday = window.location.pathname.includes('black');
const fba = window.location.pathname.includes('fba-fee-calculator');
const webApp = window.location.pathname.includes('web-app');
const auth = localStorage.getItem('emailCollect') !== null;
const proExt = document.getElementById("pro-ext");
const proExtPricing = window.location.pathname.includes('pricing');
const pPages = window.location.pathname.includes('/p/');
const chPage = document.getElementById('ch_page');
const cnPage = document.getElementById('cn_page');
const extPage = window.location.pathname === '/ext/';
const mainPage = window.location.pathname === '/' || window.location.pathname.includes('/t/2');
const testimonialsPage = document.getElementById('testimonials-page');
const screenVideo = require('./screen-video');
const navigation = require('./includes/navigation.js');
// const deals = require('./includes/deals');

adsFixer();
mainHelp.init();

if (mainPage) {
  iframeGenerator();
  stories();
  // deals.init();
  // subsribe();
} else if (document.getElementById("homepage")) {
  details();
  iframeGenerator();
  stories();
  // subsribe();
} else if (document.querySelectorAll("link[href='https://amzscout.net/courses-page/']").length > 0) {
  courseDetails();
  // subsribe();
} else if (webApp) {
  webLogin();
  // webAppButInit();
  // subsribe();
} else if (blackFriday) {
  iframeGenerator();
} else if (proExt) {
  details();
  iframeGenerator();
} else if (cnPage) {
  // deals.init();
  details();
  iframeGenerator();
  // bannerInit('#cn-ny-banner');
} else if (testimonialsPage || bundlesChristmas) {
  iframeGenerator();
}

document.getElementById('advancedDesktopNavigation') && navigation.init();

if (document.getElementById('js_homeVideoScreen')) {
  screenVideo.init('js_homeVideoScreen');
}

//Pro page - logo href
window.location.pathname == "/pro" ? $(".navbar-brand").attr("href", "/pro") : "";

//Image, slider loading
const resImage = () => {
  $('.slider').css("opacity", "1");
  const width = (blackFriday || fba) ? 768 : 992;
  let images = $('.opt');
  if ('devicePixelRatio' in window && window.devicePixelRatio > 1 && window.innerWidth > width) {
    images.each(function(i) {
      let lowres = $(this).attr('src');
      if (!lowres.includes("@") && !$(this).hasClass( "opt-svg" ) && !$(this).hasClass( "opt-one" )) {
        let highres = lowres.replace(".svg", "@2x.svg").replace(".png", "@2x.png").replace(".jpg", "@2x.jpg");
        $(this).attr('src', highres);
      }
    });
  } else if ('devicePixelRatio' in window && window.devicePixelRatio > 1 && window.innerWidth < width) {
    images.each(function(i) {
      let lowres = $(this).attr('src');
      if (!lowres.includes("@") && !$(this).hasClass( "opt-desk" ) && !$(this).hasClass( "opt-one" )) {
        let highres = lowres.replace(".svg", "@mob2x.svg").replace(".png", "@mob2x.png").replace(".jpg", "@mob2x.jpg");
        $(this).attr('src', highres);
      } else if (!$(this).hasClass( "opt-desk" ) && !$(this).hasClass( "opt-one" )) {
        let highres = lowres.replace("@mob.svg", "@mob2x.svg").replace("@mob.png", "@mob2x.png").replace("@mob.jpg", "@mob2x.jpg");
        $(this).attr('src', highres);
      }
    });
  } else if ('devicePixelRatio' in window && window.devicePixelRatio == 1 && window.innerWidth < width) {
    images.each(function(i) {
      let lowres = $(this).attr('src');
      if (!lowres.includes("@mob") && !$(this).hasClass( "opt-desk" )) {
        let highres = lowres.includes("@2x") ? lowres.replace("@2x.svg", "@mob.svg").replace("@2x.png", "@mob.png").replace("@2x.jpg", "@mob.jpg") : lowres.replace(".svg", "@mob.svg").replace(".png", "@mob.png").replace(".jpg", "@mob.jpg");
        $(this).attr('src', highres);
      }
    });
  }
  if (window.innerWidth >= width) {
    const restore = (item) => {
      let lowres = item.attr('src');
      let highres = lowres.includes("@mob2x") ? lowres.replace("@mob2x.", ".") : lowres.replace("@mob.", ".");
      item.attr('src', highres);
    }
    images.each(function(i) {
      restore($(this));
    });
  }
}


$(document).ready(function() {
  resImage();
});

window.onresize = function(e) {
  resImage();
}

//DETAILS
function details() {
  const check = document.getElementById('check');
  if (check) {
    const all = check.querySelectorAll('div, img');
    const detailsImg = document.getElementById("detailsImg");
    //default settings
    [all[0], all[1]].forEach(e => e.style.display = "block");
    check.firstElementChild.classList.add("selected-detail");
    check.addEventListener("click", (e) => {
      if (e.target.tagName == "LI") {
        all.forEach((element) => {
          element.style.display = "none";
          element.parentElement.classList.remove("selected-detail");
        });
        [e.target.lastElementChild, e.target.lastElementChild.previousElementSibling].forEach(e => e.style.display = "block");
        e.target.classList.add("selected-detail");
        log(e.target.dataset.image);
        detailsImg.src = href + "img/new/" + e.target.dataset.image;
        e.target.scrollIntoView({block: "center", behavior: "smooth"});
      }
    });
  }
}

//SCROLL animation
$(document).ready(function() {
  $(".scroll").on("click", "a", function(event) {
    if (event.target.href.includes('#') && !proExtPricing) {
      //отменяем стандартную обработку нажатия по ссылке
      event.preventDefault();
      //забираем идентификатор бока с атрибута href
      let id = $(this).attr("href");
        //узнаем высоту от начала страницы до блока на который ссылается якорь
      let top = $(id).offset().top;
      top = top - 140;
      //анимируем переход на расстояние - top за 1500 мс
      $('body, html').animate({
        scrollTop: top
      }, 1500);
    }
  });
});

$(document).ready(function() {
  $("#scrollDown").on("click", function(event) {
    //отменяем стандартную обработку нажатия по ссылке
    event.preventDefault();
    //анимируем переход на расстояние - top за 1500 мс
    $("html, body").animate({
      scrollTop: $('#pricing').offset().top
    }, 1500);
  });
});

//Iframe Generator
function iframeGenerator() {
  const links = {
    "Shimmy Morris": "https://www.youtube.com/embed/_AFq4FsWnmA",
    "Tanner J Fox": "https://www.youtube.com/embed/oZFxzL2H4UM",
    "Crescent Kao": "https://www.youtube.com/embed/1boVmzhIrO4",
    "Ecom One": "https://www.youtube.com/embed/yHmZqYVaCes",
    "Andrew Linn": "https://www.youtube.com/embed/zt2XvzSMlK4",
    "Jimmy Michalek": "https://www.youtube.com/embed/wmN297JcSog",
    "Cristian Tito": "https://www.youtube.com/embed/2k3VG3Hm0-g",
    "Riley Turner": "https://www.youtube.com/embed/zugNkRKH--w",
    "Pete Coulis": "https://www.youtube.com/embed/js1GThGOuDQ",
    "Amazon and eBay Guru": "https://www.youtube.com/embed/ObQ0lx-7HlQ",
    "Wayne Han (韩大海)": "https://www.youtube.com/embed/xvij-bisFRY",
    "Online Business Mind": "https://www.youtube.com/embed/BbwNW5OGvbU",
    "Carlos Fierro": "https://www.youtube.com/embed/-rIMisNbGR0",
    "Digital Bedouins": "https://www.youtube.com/embed/5x_TddIGueM",
    "Andy Amazon Advocate": "https://www.youtube.com/embed/iZJXZTxo98s",
    "Walter Blake Knoblock": "https://www.youtube.com/embed/yMgIJOrQgUM",
    "Side Hustle Network": "https://www.youtube.com/embed/iq5wEEpfe5I",
    "Decoded": "https://www.youtube.com/embed/GQdDezxSDSQ",
    "Scott Shafer": "https://www.youtube.com/embed/N0sJisFp5ns",
    "Roughnecks eCom": "https://www.youtube.com/embed/xB8kQ4oby1A",
    "Ryan Hogue": "https://www.youtube.com/embed/33hQHyfIJOs",
    "Adnan Maghribi": "https://www.youtube.com/embed/B-oAJ3Pe8Yc",
    "Sebastian Castaneda": "https://www.youtube.com/embed/_uJ1BbaYKYs"
  }

  $("#bloggers").on("click", "span", function(e) {
    if (e.target.className.includes('play')) {
      let name = $(this).parent().next().text();
      $("#link").attr("src", links[name] + '?modestbranding=1&iv_load_policy=3&rel=0&autohide=1&showinfo=0');
    }
  });
}

//Iframe closing
$(".close").on("click", () => {
  $("#link").attr("src", "");
});

//SUCCES STORIES
function stories() {
  $("#more").hide();

  $("#morebut").on("click", (e) => {
    event.preventDefault();
    if ($("#morebut").text() === "MORE SUCCESS STORIES") {
      $("#morebut").text("HIDE");
      $("#more").fadeIn();
    } else {
      $("#morebut").text("MORE SUCCESS STORIES");
      $("#more").fadeOut();
    }
  });
}

//Subscribe
function subsribe() {
  const form = document.getElementsByClassName("subscribe")[0];
  const inp = form.firstElementChild;
  const send = form.lastElementChild;

  function defPar() {
    form.style.opacity = "0.4";
    send.disabled = "true";
  }

  defPar();

  inp.addEventListener("focusin", (e) => {
    if (inp.value === "Enter your e-mail" || inp.value === "Invalid e-mail") {
      inp.style.color = "black";
      inp.value = "";
    }
    log(e.target.tagName);
  });

  inp.addEventListener("focusout", () => {
    if (inp.value === "") {
      inp.value = "Enter your e-mail";
    }
  });

  $('.modal-body').on("click", (e) => {
    if (e.target.parentElement.tagName == "FORM") {
      form.style.opacity = "1";
      send.removeAttribute('disabled');
    } else {
      defPar();
    }
  });

  $(send).on("click", () => {
    subscribe(inp.value);
  });

  $(inp).on("keydown", (e) => {
    if (event.which == 13 || event.keyCode == 13) {
      e.preventDefault();
      subscribe(inp.value);
    }
  });

  function subscribe(email) {
    $.ajax({
      url: `${window.location.origin}/api/v1/experiment/hypothesis10?email=${email}`,
      success: function(response) {
        window.open(response);
        $('#initModal').modal('hide');
      },
      async: false
    }).fail(function(jqXHR) {
      inp.value = "Invalid e-mail";
      inp.style.color = "red";
    });
  }

  $("#noThanks").on("click", () => {
    $('#initModal').modal('hide');
  });

  window.setTimeout(function() {
    if (JSON.parse(localStorage.getItem("modalStatus")) == null) {
      localStorage.setItem('modalStatus', "true");
      $('#initModal').modal('show');
    }
  }, 10000);
}

function courseDetails() {
  $(".course-list").on("click", "button", (e) => {
    if (e.target.textContent == "Show more") {
      $(e.target).parent().next().fadeIn();
      $(e.target).parent().hide();
    } else {
      if (e.target.parentElement.tagName == "LI") {
        $(e.target).parent().parent().parent().prev().fadeIn();
        $(e.target).parent().parent().parent().hide();
      } else {
        $(e.target).parent().parent().prev().fadeIn();
        $(e.target).parent().parent().hide();
      }
    }
  });
}

//Web-app try to free
function webAppButInit() {
  if (window.innerWidth < 1200 && !auth) {
    $('.scrollBut').fadeIn();
  }
}

function webLogin() {
  if (auth) {
    document.querySelector('.tryAmzIdLink').textContent = "Click to use Web App";
  }
}

//Cookie Disclaimer
(function disclaimer() {
  if (localStorage.getItem("disclamer") === null) {
    $(".cookie").show();
    $(".cookie").on("click", (e) => {
      if (e.target.tagName == "A" || e.target.tagName == "BUTTON") {
        $(".cookie").fadeOut();
        localStorage.setItem("disclamer", true);
      }
    });
  }
})();

//button for authorized users and Ext Page users
if (localStorage.getItem('emailCollect') !== null && (!bundles || blackFriday)) {
  const signCta = 'Find Product';
  $(".sign").text(signCta).addClass("color-link").attr("data-sign-action", signCta.replace(/\s+/g,'')).removeClass("nav-left");
} else if (extPage || mainPage) {
  $(".sign").hide();
  $(".teck_stars_desk").css('margin-right', 0);
  $('.navbar-white li').last().children().css("border-bottom-color", "transparent");
}

checkLocation();

// ----------------------------------------------------------------------------- About-page scripts
window.onload = function() {
  $(".about-team").length > 0 ? $(".about-team").removeClass("member-load") : ""
};
// ----------------------------------------------------------------------------- /About-page scripts

function navWhite (menu) {
  if ($(window).scrollTop() <= 60 && status == true && !menu) {
    $('.navbar').addClass('navWhite');
    $('.teck_stars img').attr("src", "/img/new/teck_stars@black.svg");
    $('.navbar-brand img').attr("src", "/img/new/light.svg");
    $('.navbar-toggler-icon').removeClass('toggle-black').addClass('toggler-white');
  } else {
    $('.teck_stars img').attr("src", "/img/new/teck_stars.svg");
    $('.navbar').removeClass('navWhite');
    $('.navbar-brand img').attr("src", "/img/new/dark.svg");
    $('.navbar-toggler-icon').removeClass('toggler-white').addClass('toggle-black');
  }
};

if (blackFriday) {

  navWhite ();

  $(window).scroll(function() {
    navWhite ()
  });

  const fridayTime = (year, month, day, hour, minutes) => {
    // Set the date we're counting down to
    let countDownDate = new Date(year, month, day, hour, minutes).getTime();

    // Update the count down every 1 second
    let x = setInterval(function() {

      // Get today's date and time
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, minutes
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance / 1000) % 60);

      function clearNum (num) {
        if (num < 10 || num == 0) {
          return "0" + num;
        } else {
          return num;
        }
      }

      // Display the result
      const time_points = "<span class='time_points'>:</span>";
      $('.bundle_timer_data').html("<span class='timer_d'>" + clearNum(days) + "</span>" + time_points + "<span class='timer_h'>" + clearNum(hours) + "</span>" + time_points + "<span class='timer_m'>" + clearNum(minutes) + "</span>" + time_points + "<span class='timer_s'>" + clearNum(seconds) + "</span>");
      // If the count down is finished, write some text
      if (distance <= 0) {
        $('.bundle_timer, .friday_cta').hide();
        clearInterval(x);
      }
    }, 1000);
  }
  fridayTime(2019, 10, 30, 0, 0);
}

//Pro Ext pages
const titleMov = () => {
  if (window.innerWidth <= 1199 && window.innerWidth >= 992) {
    $("h1").insertBefore($( "#custom-pos" ).parent());
  } else if ($("h1").prev().attr("class") !== "row") {
    $("h1").insertBefore($( "#custom-pos h2" ));
  }
}

const titleCollapse = () => {
  titleMov();
  window.onresize = function(e) {
    titleMov();
  }
}

pPages ? titleCollapse() : "";


//Ch page
if (chPage) {
  $("#ch_more").on("click", () => {
    if ($(".ch_more_block").css("display") == "none") {
      $(".ch_more, .bundle_details").addClass("open");
      $(".ch_more_block").slideDown(700);
      $("#ch_more").text("SHOW LESS");
    } else {
      $(".ch_more, .bundle_details").removeClass("open");
      $(".ch_more_block").slideUp(700);
      $("#ch_more").text("SHOW MORE");
    }
  });
}

//Modal Banner
function bannerInit (id) {

  $(".cn-ny-banner button").on("click", () => {
    log('hide');
    $(id).modal('hide');
    localStorage.setItem('modalBanner', "true");
  });

  window.setTimeout(function() {
    if (JSON.parse(localStorage.getItem("modalBanner")) == null) {
      $(id).modal('show');
    }
  }, 10000);
}

// ----------------------------------------------------------------------------- Quiz tool
(function() {
  const quiz = document.getElementById('quiz');
  if (quiz) {
    const chooise = document.getElementById('quiz-choose');
    quiz.addEventListener("change", (e) => {
      if (e.target.tagName === "INPUT") {
        const checked = quiz.querySelectorAll('input:checked');
        const checkedArr = Array.prototype.slice.call(checked);
        if (checkedArr.length > 0) {
          chooise.classList.remove("disabled");
          if (checkedArr.some(inp => (inp.dataset.group.includes('dreamer')))) {
            if (checkedArr.length == 1) {
              chooise.href="/tools/";
            } else {
              checkedArr.splice(0, 1);
            }
          }
          if (checkedArr.length == 6) {
            chooise.href="/tools/";
          } else if (checkedArr.length == 1) {
            checkedArr.some((inp) => {
              switch (inp.dataset.group) {
                case 'beginner-one':
                  chooise.href="/t/product-finder/";
                  break;
                case 'beginner-two':
                  chooise.href="/t/niche-finder/";
                  break;
                case 'beginner-three':
                  chooise.href="/t/profit-calculator/";
                  break;
                case 'seller':
                  chooise.href="/t/keyword-tools/";
                  break;
                case 'pro-seller':
                  chooise.href="/t/amazon-pro-tools/";
                  break;
                default:
                  break;
              }
            });
          } else if (checkedArr.length > 2 && checkedArr.every(inp => (inp.dataset.group.includes('beginner') || inp.dataset.group.includes('pro-seller'))) && checkedArr.some(inp => inp.dataset.group.includes('pro-seller'))) {
            chooise.href="/t/amazon-pro-tools/";
          } else if (checkedArr.every(inp => inp.dataset.group.includes('beginner'))) {
            if (checkedArr.length == 2 && checkedArr.every(inp => (inp.dataset.group == 'beginner-two' || inp.dataset.group == 'beginner-three'))) {
              chooise.href="/t/niche-research/";
            } else {
              chooise.href="/t/product-research/";
            }
          } else if (checkedArr.every(inp => (inp.dataset.group.includes('beginner') || inp.dataset.group.includes('seller')))) {
            chooise.href="/tools/";
          } else if (checkedArr.every(inp => (inp.dataset.group == 'pro-seller' || inp.dataset.group.includes('seller') || inp.dataset.group.includes('beginner')))) {
            chooise.href="/tools/";
          }
        } else {
          chooise.classList.add("disabled");
        }
      }
    });
  }
})();
// ----------------------------------------------------------------------------- /Quiz tool

// ----------------------------------------------------------------------------- Zoom Behavior
(function() {
  const zooms = document.getElementsByClassName('toolBlock-zoom');
  const zoomImg = document.getElementById('zoomModal-img');
  const zoomsArr = Array.prototype.slice.call(zooms);
  typeof(zoomsArr);
  if (zoomsArr) {
    zoomsArr.forEach((e) => {
      e.addEventListener("click", (event) => {
        zoomImg.src = event.target.parentElement.dataset.image;
      });
    });
  }
})();
// ----------------------------------------------------------------------------- /Zoom Behavior
// ----------------------------------------------------------------------------- PopUp
require('./includes/webinar-form.js');
// ----------------------------------------------------------------------------- /PopUp
// ----------------------------------------------------------------------------- Sales Estimator Page
require('./sales-estimator.js');
// ----------------------------------------------------------------------------- /Sales Estimator Page
// ----------------------------------------------------------------------------- Fba Calculator Page
require('./fba-calculator.js');
// ----------------------------------------------------------------------------- /Fba Calculator Page
// ----------------------------------------------------------------------------- Pricing Block
require('./pricing.js');
// ----------------------------------------------------------------------------- /Pricing Block
// ----------------------------------------------------------------------------- Email Collect
require('./includes/email-collect.js');
// ----------------------------------------------------------------------------- /Email Collect
// ----------------------------------------------------------------------------- Pricing Block
require('./pricing-block.js');
// ----------------------------------------------------------------------------- /Pricing Block
// ----------------------------------------------------------------------------- Navigation
require('./includes/old-navigation.js');
// ----------------------------------------------------------------------------- /Navigation
// ----------------------------------------------------------------------------- KWT
require('./amazon-keyword-tools.js');
// ----------------------------------------------------------------------------- /KWT
// ----------------------------------------------------------------------------- WEBINARS
require('./webinars/index');
// ----------------------------------------------------------------------------- /WEBINARS
// ----------------------------------------------------------------------------- Pro Install
require('./includes/pro-install.js');
// ----------------------------------------------------------------------------- /Pro Install
// ----------------------------------------------------------------------------- WEBINARS
const PricingController = require('./newpricing-block.js');
PricingController.init();
// ----------------------------------------------------------------------------- /WEBINARS
// ----------------------------------------------------------------------------- INFO LOCALIZATION
const InfoLocalization = require('./info-localization/index'),
  infoLocalization = new InfoLocalization();
//
// if (!about) {
  infoLocalization.init();
// }

// ----------------------------------------------------------------------------- /INFO LOCALIZATION
// ----------------------------------------------------------------------------- TESTIMONIALS
require('./includes/testimonials');
// ----------------------------------------------------------------------------- /TESTIMONIALS
// ----------------------------------------------------------------------------- TARIFFS
require('./tariffs');
// ----------------------------------------------------------------------------- /TARIFFS
